import { render, staticRenderFns } from "./Broadcast.vue?vue&type=template&id=c62a03ce&scoped=true"
import script from "./Broadcast.vue?vue&type=script&lang=js"
export * from "./Broadcast.vue?vue&type=script&lang=js"
import style0 from "./Broadcast.vue?vue&type=style&index=0&id=c62a03ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62a03ce",
  null
  
)

export default component.exports